var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(-32.678 -199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 60,
    height: 60,
    rx: 30,
    transform: "translate(32.678 199)",
    fill: "#f3f8fe",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(345.398 860.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M-283.578-618.329c-.489-.066-.983-.109-1.467-.2a12.764,12.764,0,0,1-9.16-6.664,12.073,12.073,0,0,1-1.508-6.34,12.666,12.666,0,0,1,4.772-9.69,12.439,12.439,0,0,1,6.824-2.835c.806-.082,1.622-.065,2.458-.095l-.263,2.61a10.376,10.376,0,0,0-9.055,3.871,9.82,9.82,0,0,0-2.255,7.268,10.333,10.333,0,0,0,10.286,9.493,10.035,10.035,0,0,0,7.659-3.45,10.389,10.389,0,0,0,2.629-8.021l2.6-.264.137.612v1.562c-.021.182-.042.363-.062.544a12.72,12.72,0,0,1-2.776,6.738,12.718,12.718,0,0,1-7.866,4.664c-.477.085-.96.133-1.44.2Z",
    transform: "translate(0)",
    fill: "#14d4e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M-20.66-642.112l-4.6,4.626h3.285v2.57h-7.694v-7.7h2.549v3.328l4.643-4.647c.551.552,1.077,1.08,1.606,1.6a2.55,2.55,0,0,0,.209.169Z",
    transform: "translate(-249.262 -0.204)",
    fill: "#14d4e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M-109.345-555.7h3.846v2.585h-.277c-1.956,0-3.911,0-5.867.005-.231,0-.294-.062-.293-.294q.012-4.23,0-8.46c0-.232.062-.3.294-.293.671.015,1.343.017,2.014,0,.242-.006.289.077.288.3-.008,1.939,0,3.878,0,5.817Z",
    transform: "translate(-172.185 -76.824)",
    fill: "#14d4e2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/checkIn.79b9ced6aaa5bd4a4adbfcfe0caf5ea4.svg";
export { ForwardRef as ReactComponent };